/**
 * 4Talks - Video controls
 *
 * Get search params and trigger search on page load
 *
 * JavaScript API for Ajax Search Pro plugin - ASP object
 * https://knowledgebase.ajaxsearchpro.com/other/javascript-api
 *
 * @author Matt Haynes <matthew.haynes@joipolloi.com>
 * @package Joi Polloi
 */

const siteSearch = () => {
    const search = document.querySelector('.ajaxsearchpro');
    if (!search) return;

    const searchInput = document.querySelector('.ajaxsearchpro input[type=search]');
    const searchInputText = document.querySelector('.ajaxsearchpro input[type=text]');

    const queryString = window.location.search;
    // eslint-disable-next-line compat/compat
    const urlParams = new URLSearchParams(queryString);
    const searchQuery = urlParams.get('q');

    searchInput.value = searchQuery;
    searchInputText.value = searchQuery;

    // Debounce to allow ASP API to load in
    setTimeout(() => {
        if (window.ASP) {
            window.ASP.api(2, 'searchFor', searchQuery);
        }
    }, 500);
};

export default siteSearch;
